import React, { SVGProps } from "react";

const SvgRoof7 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <g data-name="roof007 dims 1">
      <path
        fill="#b2c4d0"
        d="M135.145 181.77v34.074l176.171-101.825V79.945L135.145 181.77z"
      />
      <path
        fill="#fff"
        d="M135.145 181.833v34.011L34.65 157.959v-34.384l100.495 58.258z"
      />
      <path
        fill="#2277a9"
        d="M321.809 74.215 135.494 182.036l-8.742-113.614 92.465-53.318 102.592 59.111z"
      />
      <path
        fill="#47d6ff"
        d="m219.053 15.198-92.301 53.224-102.014 49.406L211.31 10l7.743 5.198z"
      />
      <path
        fill="#4df1ff"
        d="M135.494 182.036 24.738 117.828l102.014-49.406 8.742 113.614z"
      />
      <g fill="none">
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="m135.145 215.844.35-33.808"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="m35 123.625-.35 34.334 100.495 57.885 176.171-101.825.35-33.808"
        />
        <path
          stroke="#002839"
          strokeMiterlimit={10}
          d="m126.752 68.422 92.465-53.318"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          d="m135.495 182.036-8.743-113.614-102.014 49.407"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M135.495 182.036 24.738 117.829 211.31 10l7.907 5.104L321.81 74.215 135.495 182.036z"
        />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m110.462 230.683 19.348-11.184M10 172.817l19.302-11.226M15.103 170.314l99.77 57.466" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m163.632 232.45-19.348-11.183M340 130.76l-19.302-11.225M334.992 128.202l-175.59 101.242" />
      </g>
      <text
        transform="translate(255.857 187.187)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"B"}
      </text>
      <text
        transform="translate(54.162 212.441)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"A"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M335.226 124.008v8M158.945 225.625v8M115.247 224.038v8M14.684 166.059v8"
      />
      <text
        transform="translate(79.33 119.679)"
        fontSize={16}
        fontFamily="'Effra Regular', Effra"
      >
        {"P"}
      </text>
      <path
        d="M72.881 99.436a65.408 65.408 0 0 0 .517 8.779c1.637 12.673 6.978 21.538 14.687 26.21"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        fill="none"
        stroke="#002839"
        strokeMiterlimit={10}
        strokeDasharray={6}
        opacity={0.5}
        d="m80.599 147.177 46.129-78.735"
      />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m67.521 102.57 50.549-29.121M76.366 101.657l-6.728-3.885M84.686 136.069l6.728-3.884"
      />
    </g>
  </svg>
);

export default SvgRoof7;
